<template>
  <Motion
    :initial="{ opacity: 0, y: 30 }"
    :animate="{ opacity: 1, y: 0 }"
    :transition="{ duration: 0.7 }"
    class="text-center mb-6 sm:mb-12"
  >
    <div class="bg-gradient-to-b from-white/90 to-white/80  backdrop-blur-sm rounded-xl p-3 sm:p-6 md:p-8 shadow-lg border border-gray-100  hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1">
      <div class="flex flex-col items-center text-center space-y-3 sm:space-y-4">
        <!-- Duck announcement with animated pulse -->
        <div class="relative">
          <span class="inline-block px-3 py-1 sm:px-4 sm:py-1.5 bg-gradient-to-r from-yellow-100 to-amber-100  text-yellow-800  rounded-full text-sm font-medium mb-2 shadow-sm animate-pulse-slow">
            <span class="flex items-center gap-1">
              <v-icon size="16" color="amber-darken-2">mdi-duck</v-icon>
              Duck Found!
              <v-icon size="16" color="amber-darken-2">mdi-party-popper</v-icon>
            </span>
          </span>
        </div>
        
  <h2 class="text-xl sm:text-3xl md:text-4xl font-bold text-slate-800 leading-tight">
          <span class="text-yellow-500 fancy-underline">Conquackulations</span>, 
          <br class="md:hidden">Duck Detective!
        </h2>
        
  <p class="text-sm sm:text-lg text-gray-700  max-w-xl mx-auto mb-2">
          You've discovered one of our hidden ducks!       
            You can keep it or hide it !
        </p>
        
        <!-- SingleDuck container with enhanced styling -->
        <div class="w-full max-w-3xl mx-auto mt-4 sm:mt-8 relative">
          <SingleDuck :duck="duck" />
        </div>
        
      </div>
    </div>
  </Motion>
</template>

<script setup lang="ts">
import { defineAsyncComponent, inject } from 'vue';
import { Motion } from 'motion-v';

// Props with fallback to inject
defineProps({
  duck: {
    type: Object,
    default: () => inject('duck', null)
  }
});

// Async component import
const SingleDuck = defineAsyncComponent(() => import("@/components/duckview/SingleDuck.vue"));
</script>

<style scoped>
/* Fancy title underline */
.fancy-underline {
  position: relative;
  display: inline-block;
  z-index: 1;
}

.fancy-underline::after {
  content: '';
  position: absolute;
  bottom: -3px;
  left: 0;
  width: 100%;
  height: 6px;
  background: linear-gradient(90deg, rgba(234,179,8,0.2) 0%, rgba(234,179,8,0.6) 50%, rgba(234,179,8,0.2) 100%);
  border-radius: 6px;
  z-index: -1;
}

/* Slow pulse animation */
.animate-pulse-slow {
  animation: pulse 3s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.9;
    transform: scale(1.03);
  }
}

/* Enhanced hover effect for the card */
:deep(.bg-gradient-to-b) {
  transition: all 0.3s ease;
}

/* Make SingleDuck component respond to parent hover */
.hover\:-translate-y-1:hover :deep(.duck-container) {
  transform: scale(1.02);
  transition: transform 0.3s ease;
}

</style>